<template>
  <vs-chip :color="color">{{ message }}</vs-chip>
</template>

<script>
export default {
  name: "status-quotation",
  props: {
    invoices: {
      required: true,
      default: null
    }
  },
  computed: {
    pagado() {
      return this.payment_amount;
    },
    total_item() {
      return this.total;
    },
    message() {
      let message = "Pendiente";
      if (this.invoices > 0) {
        message = "Facturada";
      }

      return message;
    },
    color() {
      let color = "warning";

      if (this.invoices > 0) {
        color = "success";
      }

      return color;
    }
  }
};
</script>

<style></style>
